<template>
  <div class="max-w-4xl mx-auto">
    <Head title="Abrir Caja Registradora" />

    <!-- Header -->
    <div class="flex items-center gap-4 mb-8">
      <button
        class="p-3 text-white bg-teal-700 hover:bg-teal-800 rounded-lg transition-colors"
        title="Volver atrás"
        @click="back()"
      >
        <i class="fa fa-arrow-left"></i>
      </button>
      <h1 class="text-3xl font-bold">
        <Link
          class="text-teal-600 hover:text-teal-700 transition-colors"
          href="/cash-registers"
        >
          Cajas Registradoras
        </Link>
        <span class="text-gray-400 font-medium mx-2">/</span>
        <span>Abrir {{ cashRegister.name }}</span>
      </h1>
    </div>

    <!-- Form -->
    <div class="max-w-4xl bg-white rounded-lg shadow-sm border border-gray-200">
      <form @submit.prevent="open">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <!-- Cash Register Info -->
          <div class="w-full mb-6 p-4 bg-gray-50 rounded-lg">
            <h3 class="text-lg font-semibold text-gray-800 mb-2">{{ cashRegister.name }}</h3>
            <p class="text-gray-600">{{ cashRegister.description }}</p>
          </div>

          <!-- Opening Balances -->
          <div class="w-full mb-6">
            <h4 class="text-lg font-medium text-gray-800 mb-4">Saldo inicial al abrir caja</h4>
            <p class="text-sm text-gray-600 mb-4">
              Declara cuánto dinero tienes físicamente en la caja al momento de abrirla.
              Este monto debe coincidir con el efectivo disponible.
            </p>
          </div>

          <text-input
            v-model="form.opening_balance_usd"
            :error="form.errors.opening_balance_usd"
            class="pb-8 pr-6 w-full lg:w-1/3"
            label="Saldo inicial USD"
            type="number"
            step="0.01"
            min="0"
            placeholder="0.00"
          />

          <text-input
            v-model="form.opening_balance_bs"
            :error="form.errors.opening_balance_bs"
            class="pb-8 pr-6 w-full lg:w-1/3"
            label="Saldo inicial BS"
            type="number"
            step="0.01"
            min="0"
            placeholder="0.00"
          />

          <text-input
            v-model="form.opening_balance_cop"
            :error="form.errors.opening_balance_cop"
            class="pb-8 pr-6 w-full lg:w-1/3"
            label="Saldo inicial COP"
            type="number"
            step="0.01"
            min="0"
            placeholder="0.00"
          />
        </div>

        <!-- Submit -->
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <Link
            href="/cash-registers"
            class="px-4 py-2 mr-3 text-gray-600 hover:text-gray-800 transition-colors"
          >
            Cancelar
          </Link>
          <loading-button
            :loading="form.processing"
            class="px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors"
            type="submit"
          >
            Abrir Caja
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  name: 'CashRegisterOpen',

  components: {
    Head,
    Link,
    LoadingButton,
    TextInput
  },

  layout: Layout,

  props: {
    cashRegister: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        opening_balance_usd: 0,
        opening_balance_bs: 0,
        opening_balance_cop: 0,
      }),
    }
  },

  methods: {
    back() {
      window.history.back()
    },

    formatCurrency(value) {
      return new Intl.NumberFormat('es-VE', {
        style: 'currency',
        currency: 'USD'
      }).format(value || 0)
    },

    open() {
      this.form.post(`/cash-registers/${this.cashRegister.id}/open`, {
        onSuccess: () => {
          this.$inertia.visit(`/cash-registers/${this.cashRegister.id}`)
        }
      })
    },
  }
}
</script>